import { Accessor, createResource } from 'solid-js';

import { getLuzmoEmbedToken } from '../requests/evoluno/queries/getLuzmoEmbedToken';
import { getLuzmoEmbedTokenAdmin } from '../requests/evoluno/queries/getLuzmoEmbedTokenAdmin';

export const createLuzmoSsoSurvey = (dashboardAccess: Accessor<string | undefined>, companyOverride: Accessor<string | undefined>) => {
  return createResource(
    () => {
      const accessOfDashboard = dashboardAccess();
      return accessOfDashboard
        ? {
          accessOfDashboard,
          forCompany: companyOverride(),
        }
        : undefined;
    },
    async ({ accessOfDashboard, forCompany }) => {
      if (forCompany) {
        const data = await getLuzmoEmbedTokenAdmin({ realTime: false, accessOfDashboard, forCompany });
        return data.luzmoEmbedTokenAdmin;
      } else {
        const data = await getLuzmoEmbedToken({ realTime: false, accessOfDashboard});
        return data.luzmoEmbedToken;
      }
    }
  );
};
